import React from "react";

import Style from "./TaxiRequestComponents.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressBook,
  faCoins,
  faDollarSign,
  faMapPin,
} from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { separate } from "./../../Functions/NumberSeprator";
import { TaxiReqApi } from "../../Api/DeliveryBarest";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import { useHistory } from "react-router-dom";

const TaxiRequestComponents = ({ data, updateReq }) => {
  const history = useHistory();
  const OpenMapHandler = () => {
    window.open(
      `https://maps.apple.com/?q=${data.start_lat},${data.start_lon}`
    );
  };
  const acceptHandler = () => {
    let info = {
      id: data.id,
      action: "accept",
    };
    TaxiReqApi(info, (res) => {
      if (res.status === 1) {
        succToast("تایید شد! مسافر منتظر شماست.");
        updateReq();
        history.push("/taxireqcondition");
      } else {
        errorToast(res.message);
      }
    });
  };
  return (
    <li className={Style.ComponentHolder}>
      <address className={Style.AddressHolder}>
        <FontAwesomeIcon
          icon={faMapPin}
          color="#b00064"
        />
        <p>مبدا:{data?.routes_description.split("**")[0]}</p>
      </address>
      <address className={Style.AddressHolder}>
        <FontAwesomeIcon
          icon={faMapPin}
          color="#b00064"
        />
        <p>مقصد: {data?.routes_description.split("**")[1]}</p>
      </address>
      {data?.routes_description.split("**")[2]&&<address className={Style.AddressHolder}>
        <FontAwesomeIcon
          icon={faMapPin}
          color="#b00064"
          onClick={OpenMapHandler}
        />
        <p>مقصد دوم: {data?.routes_description.split("**")[2]}</p>
      </address>}
      {data?.description && (
        <address className={Style.AddressHolder}>
          <FontAwesomeIcon
            icon={faAddressBook}
            color="#b00064"
          />
          <p>توضیحات: {data?.description}</p>
        </address>
      )}
      <button className={Style.BtnAddress}>نمایش موقعیت روی نقشه</button>
      <p className={Style.passengerHolder}>
        <FontAwesomeIcon icon={faUser} color="#15a2fa" />
        {data.name}
      </p>
      <p className={Style.PriceHolder}>
        <FontAwesomeIcon icon={faCoins} color="#00d463" />
        {`${separate(data.delivery)} تومان`}
      </p>
      <button className={Style.acceptBtn} onClick={acceptHandler}>
        قبول درخواست
      </button>
    </li>
  );
};

export default TaxiRequestComponents;
